import { Image } from "@chakra-ui/react";

export default function ImageComponent({ src, alt, height }) {
  return (
    <Image
      boxSize="100%"
      height={height}
      objectFit="cover"
      src={src}
      alt={alt}
    />
  );
}
